import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckCircleIcon, GiftIcon, CheckIcon, ChevronDownIcon, LockIcon, SmartphoneIcon, CreditCardIcon } from 'lucide-react';
const PRODUCT_IMAGE = 'https://cdn.magicpatterns.com/uploads/wfCwzazkJgFyupSqRqJKQJ/heylloyd-image-1771802598740_reset_cortisol.png';
const BONUS_1_IMG = 'https://cdn.magicpatterns.com/uploads/jYW7AwDJmZK8DYTcxYwyMP/heylloyd-image-1773015601413_port_bono1.png';
const BONUS_2_IMG = 'https://cdn.magicpatterns.com/uploads/nrkvf634uKhnnZZD2g4UAK/heylloyd-image-1773015622862_port_bono2.png';
const BONUS_3_IMG = 'https://cdn.magicpatterns.com/uploads/mMtKQtynhoa89sdwDdop6t/heylloyd-image-1773015694376_port_bono_3.png';
export function OfferSection({
  onAddToCart
}: {
  onAddToCart?: () => void;
}) {
  const [expandedBonus, setExpandedBonus] = useState<number | null>(null);
  const toggleBonus = (index: number) => {
    setExpandedBonus(expandedBonus === index ? null : index);
  };
  return <section id="offer-section" className="bg-forest py-16 md:py-24" aria-labelledby="offer-heading" data-id="element-275">
      <div className="max-w-5xl mx-auto px-4" data-id="element-276">
        <motion.div initial={{
        opacity: 0,
        y: 24
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-277">
          <p className="font-sans text-terracotta text-xs font-700 tracking-[0.2em] uppercase mb-4" data-id="element-278">
            Today's Offer
          </p>
          <h2 id="offer-heading" className="font-serif text-cream text-3xl md:text-4xl lg:text-5xl font-700 leading-tight" data-id="element-279">
            Get the Complete Cortisol Reset Kitchen System
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-10 md:gap-16 items-center" data-id="element-280">
          {/* Value Stack */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} data-id="element-281">
            {/* Main Product Items */}
            <ul className="space-y-4 mb-6" role="list" data-id="element-282">
              <li className="flex items-start gap-3" data-id="element-283">
                <CheckCircleIcon className="w-5 h-5 text-terracotta flex-shrink-0 mt-0.5" aria-hidden="true" data-id="element-284" />
                <span className="font-sans text-cream text-base" data-id="element-285">
                  The 21-Day Thermal Window Flush{' '}
                  <span className="text-sage text-sm" data-id="element-286">($47 value)</span>
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-287">
                <CheckCircleIcon className="w-5 h-5 text-terracotta flex-shrink-0 mt-0.5" aria-hidden="true" data-id="element-288" />
                <span className="font-sans text-cream text-base" data-id="element-289">
                  The Sleep-to-Slim Connection Protocol{' '}
                  <span className="text-sage text-sm" data-id="element-290">($27 value)</span>
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-291">
                <CheckCircleIcon className="w-5 h-5 text-terracotta flex-shrink-0 mt-0.5" aria-hidden="true" data-id="element-292" />
                <span className="font-sans text-cream text-base" data-id="element-293">
                  The Adrenal Grocery List{' '}
                  <span className="text-sage text-sm" data-id="element-294">($17 value)</span>
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-295">
                <CheckCircleIcon className="w-5 h-5 text-terracotta flex-shrink-0 mt-0.5" aria-hidden="true" data-id="element-296" />
                <span className="font-sans text-cream text-base" data-id="element-297">
                  40+ Anti-Inflammatory Recipes{' '}
                  <span className="text-sage text-sm" data-id="element-298">($37 value)</span>
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-299">
                <CheckCircleIcon className="w-5 h-5 text-terracotta flex-shrink-0 mt-0.5" aria-hidden="true" data-id="element-300" />
                <span className="font-sans text-cream text-base" data-id="element-301">
                  <span className="text-terracotta font-700" data-id="element-302">BONUS:</span>{' '}
                  Cortisol SOS Guide{' '}
                  <span className="text-sage text-sm" data-id="element-303">($17 value — FREE)</span>
                </span>
              </li>
            </ul>

            {/* Bonus Divider */}
            <div className="border-t border-white/15 my-6" data-id="element-304" />
            <p className="font-sans text-terracotta text-xs font-700 tracking-[0.2em] uppercase mb-4 flex items-center gap-2" data-id="element-305">
              <GiftIcon className="w-4 h-4" aria-hidden="true" data-id="element-306" />3 FREE
              Companion Guides Included
            </p>

            {/* Bonus Items with Expandable Details */}
            <div className="space-y-3 mb-8" data-id="element-307">
              {/* Bonus 1 */}
              <div className="rounded-xl border border-white/15 overflow-hidden" data-id="element-308">
                <button onClick={() => toggleBonus(1)} className="w-full flex items-center justify-between gap-3 px-4 py-3 text-left transition-colors hover:bg-white/5" data-id="element-309">
                  <div className="flex items-start gap-3" data-id="element-310">
                    <GiftIcon className="w-5 h-5 text-terracotta flex-shrink-0 mt-0.5" aria-hidden="true" data-id="element-311" />
                    <span className="font-sans text-cream text-base" data-id="element-312">
                      The Restaurant Survival Blueprint{' '}
                      <span className="text-sage text-sm" data-id="element-313">
                        ($27 value — FREE)
                      </span>
                    </span>
                  </div>
                  <div className="flex items-center gap-1.5 flex-shrink-0" data-id="element-314">
                    <span className="font-sans text-terracotta text-xs font-700 hidden sm:inline" data-id="element-315">
                      {expandedBonus === 1 ? 'Close' : 'Read More'}
                    </span>
                    <ChevronDownIcon className={`w-4 h-4 text-terracotta transition-transform duration-300 ${expandedBonus === 1 ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-316" />
                  </div>
                </button>
                <AnimatePresence data-id="element-317">
                  {expandedBonus === 1 && <motion.div initial={{
                  height: 0,
                  opacity: 0
                }} animate={{
                  height: 'auto',
                  opacity: 1
                }} exit={{
                  height: 0,
                  opacity: 0
                }} transition={{
                  duration: 0.3,
                  ease: 'easeInOut'
                }} className="overflow-hidden" data-id="element-318">
                      <div className="px-4 pb-5 border-t border-white/10" data-id="element-319">
                        <img src={BONUS_1_IMG} alt="The Restaurant Survival Blueprint" className="w-full max-w-xs rounded-xl mt-4 mb-4 shadow-md" data-id="element-320" />
                        <p className="font-sans text-cream/80 text-sm italic mb-3" data-id="element-321">
                          "How to Dine Out Without Triggering a 48-Hour Cortisol
                          Bloat"
                        </p>
                        <div className="font-sans text-cream/70 text-sm space-y-2 mb-4" data-id="element-322">
                          <p data-id="element-323">
                            Most women over 55 quietly dread dinner invitations.
                            Not because they do not want the friendship — but
                            because they know what happens the next morning.
                          </p>
                          <p data-id="element-324">
                            <strong className="text-cream" data-id="element-325">
                              It is not the portion size that is the problem.
                            </strong>{' '}
                            It is the hidden cortisol triggers inside restaurant
                            kitchens.
                          </p>
                        </div>
                        <ul className="space-y-2" data-id="element-326">
                          <li className="flex items-start gap-2" data-id="element-327">
                            <CheckIcon className="w-4 h-4 text-terracotta flex-shrink-0 mt-0.5" aria-hidden="true" data-id="element-328" />
                            <span className="font-sans text-cream/80 text-sm" data-id="element-329">
                              <strong className="text-cream" data-id="element-330">
                                The 5-Second Menu Decoder
                              </strong>{' '}
                              — instantly identify cortisol-spiking ingredients
                            </span>
                          </li>
                          <li className="flex items-start gap-2" data-id="element-331">
                            <CheckIcon className="w-4 h-4 text-terracotta flex-shrink-0 mt-0.5" aria-hidden="true" data-id="element-332" />
                            <span className="font-sans text-cream/80 text-sm" data-id="element-333">
                              <strong className="text-cream" data-id="element-334">
                                The Cuisine-by-Cuisine Safe List
                              </strong>{' '}
                              — Italian, Mexican, Asian, American
                            </span>
                          </li>
                          <li className="flex items-start gap-2" data-id="element-335">
                            <CheckIcon className="w-4 h-4 text-terracotta flex-shrink-0 mt-0.5" aria-hidden="true" data-id="element-336" />
                            <span className="font-sans text-cream/80 text-sm" data-id="element-337">
                              <strong className="text-cream" data-id="element-338">
                                The Anti-Inflammatory Bar Order
                              </strong>{' '}
                              — what to drink and still feel social
                            </span>
                          </li>
                          <li className="flex items-start gap-2" data-id="element-339">
                            <CheckIcon className="w-4 h-4 text-terracotta flex-shrink-0 mt-0.5" aria-hidden="true" data-id="element-340" />
                            <span className="font-sans text-cream/80 text-sm" data-id="element-341">
                              <strong className="text-cream" data-id="element-342">
                                The Morning-After Reset Protocol
                              </strong>{' '}
                              — wake up lighter after a dinner out
                            </span>
                          </li>
                        </ul>
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </div>

              {/* Bonus 2 */}
              <div className="rounded-xl border border-white/15 overflow-hidden" data-id="element-343">
                <button onClick={() => toggleBonus(2)} className="w-full flex items-center justify-between gap-3 px-4 py-3 text-left transition-colors hover:bg-white/5" data-id="element-344">
                  <div className="flex items-start gap-3" data-id="element-345">
                    <GiftIcon className="w-5 h-5 text-terracotta flex-shrink-0 mt-0.5" aria-hidden="true" data-id="element-346" />
                    <span className="font-sans text-cream text-base" data-id="element-347">
                      The 11 PM Emergency Snack List{' '}
                      <span className="text-sage text-sm" data-id="element-348">
                        ($19 value — FREE)
                      </span>
                    </span>
                  </div>
                  <div className="flex items-center gap-1.5 flex-shrink-0" data-id="element-349">
                    <span className="font-sans text-terracotta text-xs font-700 hidden sm:inline" data-id="element-350">
                      {expandedBonus === 2 ? 'Close' : 'Read More'}
                    </span>
                    <ChevronDownIcon className={`w-4 h-4 text-terracotta transition-transform duration-300 ${expandedBonus === 2 ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-351" />
                  </div>
                </button>
                <AnimatePresence data-id="element-352">
                  {expandedBonus === 2 && <motion.div initial={{
                  height: 0,
                  opacity: 0
                }} animate={{
                  height: 'auto',
                  opacity: 1
                }} exit={{
                  height: 0,
                  opacity: 0
                }} transition={{
                  duration: 0.3,
                  ease: 'easeInOut'
                }} className="overflow-hidden" data-id="element-353">
                      <div className="px-4 pb-5 border-t border-white/10" data-id="element-354">
                        <img src={BONUS_2_IMG} alt="The 11 PM Emergency Snack List" className="w-full max-w-xs rounded-xl mt-4 mb-4 shadow-md" data-id="element-355" />
                        <p className="font-sans text-cream/80 text-sm italic mb-3" data-id="element-356">
                          "12 Cortisol-Lowering Snacks That Help You Sleep
                          Deeper and Wake Up Lighter"
                        </p>
                        <div className="font-sans text-cream/70 text-sm space-y-2 mb-4" data-id="element-357">
                          <p data-id="element-358">
                            When you go to bed with low blood sugar, your
                            cortisol surges to compensate. That surge is the
                            exact reason you wake up at 3 AM.
                          </p>
                          <p data-id="element-359">
                            <strong className="text-cream" data-id="element-360">
                              Going to bed hungry is not discipline. It is a
                              cortisol event.
                            </strong>
                          </p>
                        </div>
                        <ul className="space-y-2" data-id="element-361">
                          <li className="flex items-start gap-2" data-id="element-362">
                            <CheckIcon className="w-4 h-4 text-terracotta flex-shrink-0 mt-0.5" aria-hidden="true" data-id="element-363" />
                            <span className="font-sans text-cream/80 text-sm" data-id="element-364">
                              <strong className="text-cream" data-id="element-365">
                                The Safety Boat Snack
                              </strong>{' '}
                              — 1 ingredient, 60 seconds, signals your adrenals
                              to stand down
                            </span>
                          </li>
                          <li className="flex items-start gap-2" data-id="element-366">
                            <CheckIcon className="w-4 h-4 text-terracotta flex-shrink-0 mt-0.5" aria-hidden="true" data-id="element-367" />
                            <span className="font-sans text-cream/80 text-sm" data-id="element-368">
                              <strong className="text-cream" data-id="element-369">
                                The Melatonin Precursor Combo
                              </strong>{' '}
                              — puts your body into fat-burning sleep mode
                            </span>
                          </li>
                          <li className="flex items-start gap-2" data-id="element-370">
                            <CheckIcon className="w-4 h-4 text-terracotta flex-shrink-0 mt-0.5" aria-hidden="true" data-id="element-371" />
                            <span className="font-sans text-cream/80 text-sm" data-id="element-372">
                              <strong className="text-cream" data-id="element-373">
                                The No-Go After-9 PM List
                              </strong>{' '}
                              — 3 foods secretly spiking your cortisol all night
                            </span>
                          </li>
                          <li className="flex items-start gap-2" data-id="element-374">
                            <CheckIcon className="w-4 h-4 text-terracotta flex-shrink-0 mt-0.5" aria-hidden="true" data-id="element-375" />
                            <span className="font-sans text-cream/80 text-sm" data-id="element-376">
                              <strong className="text-cream" data-id="element-377">
                                The 4-Step Cortisol Shutdown Protocol
                              </strong>{' '}
                              — your new nightly closing ritual
                            </span>
                          </li>
                        </ul>
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </div>

              {/* Bonus 3 */}
              <div className="rounded-xl border border-white/15 overflow-hidden" data-id="element-378">
                <button onClick={() => toggleBonus(3)} className="w-full flex items-center justify-between gap-3 px-4 py-3 text-left transition-colors hover:bg-white/5" data-id="element-379">
                  <div className="flex items-start gap-3" data-id="element-380">
                    <GiftIcon className="w-5 h-5 text-terracotta flex-shrink-0 mt-0.5" aria-hidden="true" data-id="element-381" />
                    <span className="font-sans text-cream text-base" data-id="element-382">
                      The 7-Minute Metabolic Spark{' '}
                      <span className="text-sage text-sm" data-id="element-383">
                        ($29 value — FREE)
                      </span>
                    </span>
                  </div>
                  <div className="flex items-center gap-1.5 flex-shrink-0" data-id="element-384">
                    <span className="font-sans text-terracotta text-xs font-700 hidden sm:inline" data-id="element-385">
                      {expandedBonus === 3 ? 'Close' : 'Read More'}
                    </span>
                    <ChevronDownIcon className={`w-4 h-4 text-terracotta transition-transform duration-300 ${expandedBonus === 3 ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-386" />
                  </div>
                </button>
                <AnimatePresence data-id="element-387">
                  {expandedBonus === 3 && <motion.div initial={{
                  height: 0,
                  opacity: 0
                }} animate={{
                  height: 'auto',
                  opacity: 1
                }} exit={{
                  height: 0,
                  opacity: 0
                }} transition={{
                  duration: 0.3,
                  ease: 'easeInOut'
                }} className="overflow-hidden" data-id="element-388">
                      <div className="px-4 pb-5 border-t border-white/10" data-id="element-389">
                        <img src={BONUS_3_IMG} alt="The 7-Minute Metabolic Spark" className="w-full max-w-xs rounded-xl mt-4 mb-4 shadow-md" data-id="element-390" />
                        <p className="font-sans text-cream/80 text-sm italic mb-3" data-id="element-391">
                          "The Joint-Safe Morning Routine That Wakes Up Your
                          Thyroid Without Spiking Your Stress Hormones"
                        </p>
                        <div className="font-sans text-cream/70 text-sm space-y-2 mb-4" data-id="element-392">
                          <p data-id="element-393">
                            It is 7 minutes. In your pajamas. Barefoot, if you
                            want. A cortisol-conscious movement protocol
                            designed specifically for women over 55.
                          </p>
                          <p data-id="element-394">
                            <strong className="text-cream" data-id="element-395">
                              No jumping. No equipment. No joint pain.
                            </strong>
                          </p>
                        </div>
                        <ul className="space-y-2" data-id="element-396">
                          <li className="flex items-start gap-2" data-id="element-397">
                            <CheckIcon className="w-4 h-4 text-terracotta flex-shrink-0 mt-0.5" aria-hidden="true" data-id="element-398" />
                            <span className="font-sans text-cream/80 text-sm" data-id="element-399">
                              <strong className="text-cream" data-id="element-400">
                                The 4-Movement Release Circuit
                              </strong>{' '}
                              — 90 seconds each, zero impact, any room
                            </span>
                          </li>
                          <li className="flex items-start gap-2" data-id="element-401">
                            <CheckIcon className="w-4 h-4 text-terracotta flex-shrink-0 mt-0.5" aria-hidden="true" data-id="element-402" />
                            <span className="font-sans text-cream/80 text-sm" data-id="element-403">
                              <strong className="text-cream" data-id="element-404">
                                The 2 Thermal Window Timing Slots
                              </strong>{' '}
                              — when these 7 minutes burn 3x more
                            </span>
                          </li>
                          <li className="flex items-start gap-2" data-id="element-405">
                            <CheckIcon className="w-4 h-4 text-terracotta flex-shrink-0 mt-0.5" aria-hidden="true" data-id="element-406" />
                            <span className="font-sans text-cream/80 text-sm" data-id="element-407">
                              <strong className="text-cream" data-id="element-408">
                                The Exhale Rhythm Rule
                              </strong>{' '}
                              — know if you are helping or hurting your cortisol
                            </span>
                          </li>
                          <li className="flex items-start gap-2" data-id="element-409">
                            <CheckIcon className="w-4 h-4 text-terracotta flex-shrink-0 mt-0.5" aria-hidden="true" data-id="element-410" />
                            <span className="font-sans text-cream/80 text-sm" data-id="element-411">
                              <strong className="text-cream" data-id="element-412">
                                The Energy Check-In Guide
                              </strong>{' '}
                              — know within 60 seconds if your body is
                              responding
                            </span>
                          </li>
                        </ul>
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </div>
            </div>

            {/* Price */}
            <div className="bg-white/10 rounded-2xl p-6 mb-6 border border-white/20" data-id="element-413">
              <p className="font-sans text-sage text-sm mb-1" data-id="element-414">Total Value:</p>
              <p className="font-serif text-cream/60 text-2xl line-through mb-1" data-id="element-415">
                $220
              </p>
              <p className="font-serif text-cream text-4xl font-700" data-id="element-416">
                Today Only: <span className="text-terracotta" data-id="element-417">$6.36</span>
              </p>
              <p className="font-sans text-sage text-sm mt-2" data-id="element-418">
                The price of one lunch. The solution you've been searching for.
              </p>
            </div>

            {/* CTA */}
            <a href="https://buenavibrax.com/cart/45502602674233:1" onClick={e => {
            if (onAddToCart) {
              e.preventDefault();
              onAddToCart();
            }
          }} className="block w-full bg-terracotta hover:bg-terracotta/90 text-white font-sans font-700 text-lg px-8 py-4 rounded-xl transition-all duration-200 shadow-lg hover:shadow-xl hover:-translate-y-0.5 mb-5 text-center" aria-label="Get instant access to the Cortisol Reset Kitchen for $6.36" data-id="element-419">
              YES! Give Me Instant Access for $6.36 →
            </a>

            {/* Trust Badges */}
            <div className="flex flex-wrap justify-center gap-4 text-sage text-sm font-sans" data-id="element-420">
              <span className="flex items-center gap-1.5" data-id="element-421">
                <LockIcon className="w-4 h-4" aria-hidden="true" data-id="element-422" />
                Secure Checkout
              </span>
              <span className="flex items-center gap-1.5" data-id="element-423">
                <SmartphoneIcon className="w-4 h-4" aria-hidden="true" data-id="element-424" />
                Instant Download
              </span>
              <span className="flex items-center gap-1.5" data-id="element-425">
                <CreditCardIcon className="w-4 h-4" aria-hidden="true" data-id="element-426" />
                All Cards Accepted
              </span>
            </div>
          </motion.div>

          {/* Product Image */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.7,
          delay: 0.1
        }} className="flex justify-center" data-id="element-427">
            <div className="relative" data-id="element-428">
              <div className="absolute inset-0 bg-terracotta/20 rounded-3xl blur-2xl transform scale-90 translate-y-6" aria-hidden="true" data-id="element-429" />
              <img src={PRODUCT_IMAGE} alt="The Cortisol Reset Kitchen digital guide" className="relative w-full max-w-xs rounded-2xl shadow-2xl" data-id="element-430" />
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}